import { actions } from "../../utils/constants";


export const BeneficiaryValidateAction = (response) => {
    return { type: actions.BENEFICIARY_VALIDATE, value: response }
}


export const BeneficiaryRawVideoCountAction = (response) => {
    return { type: actions.BENEFICIARY_RAWVIDEO_COUNT, value: response }
}

export const BeneficiaryRawVideoDataAction = (response) => {
    return { type: actions.BENEFICIARY_RAWVIDEO_DATA, value: response }
}